//src/hooks/useSolicitarFormacion.ts
import { useMutation } from "@tanstack/react-query";
import { postFormacion, CrearFormacionPayload } from "../api/formaciones";

export function useSolicitarFormacion() {
  return useMutation({
    mutationFn: (payload: CrearFormacionPayload) => postFormacion(payload),
  });
}
